import { Dropdown, MenuItem } from "react-bootstrap";

import { FormattedMessage } from "react-intl";
import React from "react";

const SupplierActionButton = ({ availableActions, deleteSupplier}) => {
  return (
    <Dropdown
      pullRight
      id="supplier-actions-dropdown"
      className="dropdown-action-btn pull-right">
      <Dropdown.Toggle className="btn-wd btn-icon">
        <i className="fa fa-lg fa-check" />
        Action
      </Dropdown.Toggle>
      <Dropdown.Menu className="action-dropdown-menu">
        {availableActions.includes("DELETESUPPLIER") ? (
          <MenuItem
            onClick={() => {
              console.log("call deleteSupplier()");
              deleteSupplier();
            }}
            eventKey="1">
            <i className="fa fa-lg fa-trash" />

            <FormattedMessage id="ids_deleteSupplier" />
          </MenuItem>
        ) : (
          <div />
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default SupplierActionButton;
